<template>
  <div class="page-info">
    <img :src="imgUrl || imgSrc" alt="">
  </div>
</template>
<script>
import imgSrc from '../../assets/images/page-info.png'
export default {
  props: {
    imgUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      imgSrc
    }
  }
}
</script>
<style>
.page-info {
  width: 100%;
  overflow-x: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>